// extracted by css-extract-rspack-plugin
export default {"ParameterPanel":"vPl_5","AllowSticky":"msOOh","IsSticky":"kM0g6","CompactExportAsPdfButton":"Fu6g6","ParametersVisibleWithNoTabs":"Bh5nu"};